import React from 'react';
import { downloadLinks } from '../../constants/links';

export const DownloadSection: React.FC = () => {
    return (
        <div style={{
            backgroundColor: '#f3f4f6',
            padding: '20px',
            borderRadius: '8px',
            marginTop: '32px'
        }}>
            <h3 style={{ marginBottom: '8px' }}>Download Our App</h3>

            <div style={{ display: 'flex', gap: '12px' }}>
                <a
                    href={downloadLinks.appStore}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ flex: 1 , display: 'none' }}
                >
                    <img
                        src="/images/download/app-store.svg"
                        alt="Download on the App Store"
                        style={{
                            width: '100%',
                            height: 'auto',
                            cursor: 'pointer'
                        }}
                    />
                </a>

                <a
                    href={downloadLinks.playStore}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ flex: 1 }}
                >
                    <img
                        src="/images/download/play-store.svg"
                        alt="Get it on Google Play"
                        style={{
                            width: '100%',
                            height: 'auto',
                            cursor: 'pointer'
                        }}
                    />
                </a>

                <a
                    href={downloadLinks.appStore}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ flex: 1 }}
                >
                    <img
                        src="/images/download/app-store.svg"
                        alt="Get it on the App Store"
                        style={{
                            width: '100%',
                            height: 'auto',
                            cursor: 'pointer'
                        }}
                    />
                </a>
            </div>
        </div>
    );
}